import React, { useState, useEffect, useContext } from 'react';
import { LykioContext } from "../routing/LykioAuthorizedRoute";
import axios from 'axios';
import './home.css';
import { AUTHORIZED_URL_PREFIX, HOME_DATA_URL,STORIES_URL, AxiosConfig } from '../../Utils/Constants';
import Loading from '../common/Loading';
import { notify, pleaseRefreshError } from '../../Utils/Notificator';
import t from '../../Utils/Translation';
import Units from './Units';
import FeaturedStory from './FeaturedStory';
import FeaturedStories from './FeaturedStories';
import { ErrorBoundary } from 'react-error-boundary';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import HomeStats from './HomeStats';
import ProfileBox from '../common/ProfileBox';
import EmptyCard from '../common/EmptyCard';
import UnitSplider from '../common/UnitSplider';
import FeaturedStoriesSplider from '../common/FeaturedStoriesSplider';
import Footer from './../common/Footer';

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <div role="alert">
      <p>{t('Something went wrong')}</p>
      <pre>{error.message}</pre>
      <button onClick={resetErrorBoundary}>{t('Try again')}</button>
    </div>
  );
};

const Home = () => {
	const context = useContext(LykioContext);
  const userDetails = context.userDetails;
	const tenantProperties = context.tenantProperties;
	const storiesName = tenantProperties && tenantProperties.storiesName ? tenantProperties.storiesName : "Stories";
  const tenantName = tenantProperties && tenantProperties.name ? tenantProperties.name : "Lykio";
  const initiative = (tenantProperties && tenantProperties.initiative) && tenantProperties.initiative;
	const [ featuredStory, setFeaturedStory ] = useState();
  const [ featuredStories, setFeaturedStories ] = useState([]);
	const [ mostUsed, setMostUsed ] = useState([]);
	const [ topRated, setTopRated ] = useState([]);
	const [ newUnits, setNewUnits ] = useState([]);
	const [numberOfGroups, setNumberOfGroups ] = useState(0);
	const [numberOfActiveUsers, setNumberOfActiveUsers ] = useState(0);
	const [numberOfActiveUnits, setNumberOfActiveUnits ] = useState(0);
	const [numberOfApprovedStories, setNumberOfApprovedStories ] = useState(0);
	const [ isLoading, setIsLoading ] = useState(true);
	const language = localStorage.getItem('content-i18n');

	useEffect(() => {
		const fetchHomeData = async () => {
			try {
				const { data } = await axios.post(`${AUTHORIZED_URL_PREFIX}${HOME_DATA_URL}`,{language}, AxiosConfig());
				
        setFeaturedStory(data.featuredStory);
        setFeaturedStories(data.featuredStories);
				setMostUsed(data.mostUsed ? data.mostUsed : []);
				setNewUnits(data.newUnits ? data.newUnits : []);
				setTopRated(data.topRated ? data.topRated : []);
				setNumberOfGroups(data.numberOfGroups);
				setNumberOfActiveUsers(data.numberOfActiveUsers);
				setNumberOfActiveUnits(data.numberOfActiveUnits);
				setNumberOfApprovedStories(data.numberOfApprovedStories);
				setIsLoading(false);
				if (!data.success) {
					notify(pleaseRefreshError);
				}
			} catch (error) {
				console.log(error);
			}
		};
		fetchHomeData();
	}, []);

	return (
    <div className="lykioccs-main-content lykiocss-home">
      {isLoading ? (
        <Loading />
      ) : (
        <React.Fragment>
          <Container style={{marginLeft:'0em !important'}}>
            <Row>
              <Col xs={12}>
                <h1 className="lykiocss-home-title">{initiative ? initiative : tenantName}</h1>
                <p className="lykiocss-home-decription">{t("The Mindful Ageing Online Academy consists of an online toolkit of resources and an online network for older people and support workers.")}<br/>
                {t("Through the educational modules, you can acquire knowledge about mindfulness techniques and their importance in older ages. The resources provided in this platform are useful to combat feelings of isolation, and low self-esteem and help improve physical and mental well-being.")}<br/>
                {t("Are you a senior user interested in Maintaining a healthy body and mind through Mindfulness techniques? Are you a support worker actively working with seniors?")}<br/>
                {t("Go through the educational modules and find the relevant information!")}<br/>
                {t("Badges will be attributed, and your experience will get higher as long as you achieve goals in the Mindful Ageing Online Academy!")}<br/>
                {t("Do you want to contribute by uploading your content and/or stories? Visit the Stories section and upload your content to make it available to other users.")}<br/>
                {t("*Note that: The content will be available after the approval of the platform's administrators.")}</p>
              </Col>
            </Row>
            <Row style={{marginTop:'1em'}}>
                <Col xs={12}>
                  <Row className="lykiocss-home-stats-wrapper">
                    {(userDetails && userDetails.settings.dashboard.showProgress) && (
                      <Col className="lykiocss-home-stats lykiocss-margin-top-half-em">
                        {/* <EmptyCard title="Progress" destination={`/profile/${userDetails && userDetails.id}`} destinationTitle="Profile"> */}
                        <EmptyCard>
                          <ProfileBox userDetails={userDetails} />
                        </EmptyCard>
                      </Col>
                    )}

                  {/*(userDetails && userDetails.settings.dashboard.showProgress) && (
                      <Col className="lykiocss-home-stats lykiocss-home-stats2 lykiocss-margin-top-half-em">
                        <EmptyCard title={t(`Your Achievements`)}>
                          <ProfileBox userDetails={userDetails} />
                        </EmptyCard>
                      </Col>
                  )*/}

                    {userDetails && userDetails.settings.dashboard.showHomeStats && (
                      <Col className="lykiocss-home-stats lykiocss-home-stats3 lykiocss-margin-top-half-em">
                        {/* <HomeStats numberOfGroups={numberOfGroups} numberOfActiveUsers={numberOfActiveUsers} numberOfActiveUnits={numberOfActiveUnits} numberOfApprovedStories={numberOfApprovedStories}/> */}
                        <EmptyCard title={t("Platform at a glance")}>
                          <HomeStats numberOfGroups={numberOfGroups} numberOfActiveUsers={numberOfActiveUsers} numberOfActiveUnits={numberOfActiveUnits} numberOfApprovedStories={numberOfApprovedStories}/>
                        </EmptyCard>  
                      </Col>
                    )}
                  </Row>
                </Col> 
              </Row>
          </Container>

          {featuredStories.length > 0 && userDetails && userDetails.settings.dashboard.showFeatured && (
          <div style={{marginTop:'1em', marginLeft:'1em'}}>
          <Units title={t("Featured Stories")} units={featuredStories}/>
          </div>
          )}

          <div style={{marginTop:'1em', marginLeft:'1em'}}>
          <Units title={t("New Units")} units={newUnits}/>
          </div>
          <div style={{marginTop:'1em', marginLeft:'1em'}}>
            <Units title={t("Most Used")} units={mostUsed}/>
          </div>
          <div style={{marginTop:'1em', marginLeft:'1em'}}>
            <Units title={t("Top Rated")} units={topRated}/>
          </div>
          </React.Fragment>
      )}
      <div className="lykiocss-home-footer">
        <Footer />
      </div>
    </div>
  );
};

export default Home;
